import lang from '@/lang/commissions';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en, 'commissions');
  const title = store.$i18n.t('commissions.title');
  const description = title;
  store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'expanded' });
  store.commit('pageContent/setHead', { title, description });
};
